import { matches } from 'validator';

function isOnlyWords(str: string) {
  // Matches any character that is not a digit
  const regex = /^[^\d]+$/;
  return matches(str, regex);
}

function isNotOnlyWords(str: string) {
  return !isOnlyWords(str);
}

export { isNotOnlyWords };
